import {Component} from '@angular/core';
import {AppService} from '@api';
import {SistemaService} from '@servicios/Sistema.Service';

@Component(
  {
    selector: ' token',
    templateUrl: './Token.template.html',
  })

export class TokenComponent
{
  public abierto : boolean = false;
  public animacion : string = "";

  public tokens : Array<any> = [];


  constructor(private appService:AppService, public sistemaService : SistemaService)
  {
  }

  ngOnInit()
  {
  }

  AbrirModal(tokens : Array<any>)
  {
    this.tokens = tokens;
    this.animacion = this.sistemaService.animacionAbirModal;
    this.abierto = true;
  }

  CerrarModal()
  {
    this.animacion = this.sistemaService.animacionCerrarModal;

    setTimeout(() =>
    {
      this.abierto = false;
    }, 310);
  }
}
